module.exports = __webpack_public_path__ + "img/nach-document.34e3577c.png";